import { EmptyMessageBox, MessageBox } from '@/business/message/models/message-box'

export interface MessageState {
  inbox: MessageBox
}

export const EmptyMessageState: MessageState = {
  inbox: EmptyMessageBox,
}
